import React from 'react';
import czaricino_01 from '../../../images/murmansk/czaricino_01.jpg';
import czaricino_02 from '../../../images/murmansk/czaricino_02.jpg';
import czaricino_03 from '../../../images/murmansk/czaricino_03.jpg';
import moskow_01 from '../../../images/murmansk/moskow_01.jpg';
import moskow_02 from '../../../images/murmansk/moskow_02.jpg';
import moskowPodMostom from '../../../images/murmansk/moskowPodMostom.jpg';
import murmansk_01 from '../../../images/murmansk/murmansk_01.jpg';
import teriberka_01 from '../../../images/murmansk/teriberka_01.jpg';
import teriberka_02 from '../../../images/murmansk/teriberka_02.jpg';
import teriberka_03 from '../../../images/murmansk/teriberka_03.jpg';
import teriberka_04 from '../../../images/murmansk/teriberka_04.jpg';
import teriberka_05 from '../../../images/murmansk/teriberka_05.jpg';
import teriberka_06 from '../../../images/murmansk/teriberka_06.jpg';
import glamping_01 from '../../../images/murmansk/glamping_01.jpg';
import glamping_02 from '../../../images/murmansk/glamping_02.jpg';
import glamping_04 from '../../../images/murmansk/glamping_04.jpg';
import glamping_05 from '../../../images/murmansk/glamping_05.jpg';
import khibiny_01 from '../../../images/murmansk/khibiny_01.jpg';
import khibiny_02 from '../../../images/murmansk/khibiny_02.jpg';
import murmansk_02 from '../../../images/murmansk/murmansk_02.jpg';
import murmansk_03 from '../../../images/murmansk/murmansk_03.jpg';
import murmansk_04 from '../../../images/murmansk/murmansk_04.jpg';
import murmansk_05 from '../../../images/murmansk/murmansk_05.jpg';
import tundra_01 from '../../../images/murmansk/tundra_01.jpg';
import tundra_02 from '../../../images/murmansk/tundra_02.jpg';
import moskowBack from '../../../images/murmansk/moskowBack.jpg';
import tulskaya from '../../../images/murmansk/moskowTulskaya.jpg';
import tulskayaFlat from '../../../images/murmansk/moskowLastFlat.jpg';
import moskowCity_01 from '../../../images/murmansk/moskowCity_01.jpg';
import moskowCity_02 from '../../../images/murmansk/moskowCity_02.jpg';
import moskowVDNH_01 from '../../../images/murmansk/moskowVDNH_01.jpg';
import moskowVDNH_02 from '../../../images/murmansk/moskowVDNH_02.jpg';
import moskowVDNH_03 from '../../../images/murmansk/moskowVDNH_03.jpg';
import moskowVDNH_04 from '../../../images/murmansk/moskowVDNH_04.jpg';
import moskowLeto_01 from '../../../images/murmansk/moskowLeto_01.jpg';
import moskowLeto_03 from '../../../images/murmansk/moskowLeto_03.jpg';
import moskowLeto_02 from '../../../images/murmansk/moskowLeto_02.jpg';
import moskowLeto_04 from '../../../images/murmansk/moskowLeto_04.jpg';
import moskowNewArc_01 from '../../../images/murmansk/moskow_newArc_01.jpg';
import moskowNewArc_02 from '../../../images/murmansk/moskow_newArc_02.jpg';
import moskowNewArc_03 from '../../../images/murmansk/moskow_newArc_03.jpg';
import moskowWalk_01 from '../../../images/murmansk/moskowWalk_01.jpg';
import moskowWalk_02 from '../../../images/murmansk/moskowWalk_02.jpg';
import moskowWalk_03 from '../../../images/murmansk/moskowWalk_03.jpg';
import moskowWalk_04 from '../../../images/murmansk/moskowWalk_04.jpg';
import moskowWalk_05 from '../../../images/murmansk/moskowWalk_05.jpg';
import moskowWalk_06 from '../../../images/murmansk/moskowWalk_06.jpg';
import yandexMuseum_01 from '../../../images/murmansk/yandexMuseum_01.jpg';
import yandexMuseum_02 from '../../../images/murmansk/yandexMuseum_02.jpg';
import yandexMuseum_03 from '../../../images/murmansk/yandexMuseum_03.jpg';
import yandexMuseum_04 from '../../../images/murmansk/yandexMuseum_04.jpg';
import yandexMuseum_05 from '../../../images/murmansk/yandexMuseum_05.jpg';
import yandexMuseum_06 from '../../../images/murmansk/yandexMuseum_06.jpg';
import yandexMuseum_07 from '../../../images/murmansk/yandexMuseum_07.jpg';



const Murmansk = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-12">

                    <p>
                    Ближе к&nbsp;концу августа 2025&nbsp;года, мы&nbsp;едем в&nbsp;Москву, там встречаем нашего стародавнего друга, чтобы всем вместе отправиться в&nbsp;Мурманскую область.
                    </p>

                    <p>
                    У&nbsp;нас есть денёк чтобы погулять по&nbsp;Москве. Едем в&nbsp;Царицино. И&nbsp;не&nbsp;только.
                    </p>

                   
                    <div id="czaricino" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#czaricino" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#czaricino" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#czaricino" data-bs-slide-to="2"
                                    aria-label="Slide 3"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={czaricino_01} className="d-block w-100" alt="Москва"/>
                            </div>
                            <div className="carousel-item">
                                <img src={czaricino_02} className="d-block w-100" alt="Москва"/>
                            </div>
                            <div className="carousel-item">
                                <img src={czaricino_03} className="d-block w-100" alt="Москва"/>
                            </div>
                            <div className="carousel-item">
                                <img src={moskow_01} className="d-block w-100" alt="Москва"/>
                            </div>
                            <div className="carousel-item">
                                <img src={moskow_02} className="d-block w-100" alt="Москва"/>
                            </div>
                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#czaricino"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#czaricino"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    Также, пользуясь случаем, посещаем легендарную площадку под мостами.
                    </p>

                    <img src={moskowPodMostom} className="img-fluid travel__img" loading="lazy" alt="Москва"/>

                    <p>
                    Далее вылетаем в&nbsp;Мурманск. Заселяемся в&nbsp;квартире панельного дома. Вид такой...
                    </p>

                    <img src={murmansk_01} className="img-fluid travel__img" loading="lazy" alt="Мурманск"/>
                    
                    <p>
                    На&nbsp;следующий день берём машину на&nbsp;прокат. Едем в&nbsp;Териберку, на&nbsp;берег Баренцева моря.
                    </p>

                    <img src={teriberka_01} className="img-fluid travel__img" loading="lazy" alt="Мурманск"/>

                    <p>
                    Погода не&nbsp;балует. Но&nbsp;это природа этих мест. Приезжаем в&nbsp;Териберку и&nbsp;идём по&nbsp;туристической тропе для осмотра достопримечательностей.
                    </p>

                    <div id="teriberka" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#teriberka" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#teriberka" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#teriberka" data-bs-slide-to="2"
                                    aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#teriberka" data-bs-slide-to="3"
                                    aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#teriberka" data-bs-slide-to="4"
                                    aria-label="Slide 5"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={teriberka_02} className="d-block w-100" alt="Териберка"/>
                            </div>
                            <div className="carousel-item">
                                <img src={teriberka_03} className="d-block w-100" alt="Териберка"/>
                            </div>
                            <div className="carousel-item">
                                <img src={teriberka_04} className="d-block w-100" alt="Териберка"/>
                            </div>
                            <div className="carousel-item">
                                <img src={teriberka_05} className="d-block w-100" alt="Териберка"/>
                            </div>
                            <div className="carousel-item">
                                <img src={teriberka_06} className="d-block w-100" alt="Териберка"/>
                            </div>
                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#teriberka"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#teriberka"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    Дойдя до&nbsp;мыса, с&nbsp;океана внезапно начинает задувать сильный ветер. Тучи находят мгновенно и&nbsp;начинается сильный дождь. До&nbsp;этого я&nbsp;считал, что моя куртка непромокаемая...
                    </p>

                    <p>
                    Плетёмся до&nbsp;машины. Промокшие насквозь, садимся в&nbsp;неё и&nbsp;отправляемся в&nbsp;обратный путь.
                    </p>

                    <p>
                    Переночевав и&nbsp;просушив вещи, на&nbsp;следующий день отправляемся на&nbsp;юг&nbsp;в&nbsp;горы Хибины.
                    </p>

                    <p>
                    Добираемся до&nbsp;города Кировск, обедаем там, а&nbsp;затем едем к&nbsp;месту нашего отдыха глэмпингу &laquo;На&nbsp;севере&raquo;.
                    </p>

                    <p>
                    Место открылось совсем недавно, здесь отличная материальная база, но&nbsp;коллективу тогда ещё не&nbsp;хватало слаженности, да&nbsp;и&nbsp;простого опыта.
                    </p>

                    <div id="glamping" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#glamping" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#glamping" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#glamping" data-bs-slide-to="2"
                                    aria-label="Slide 3"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={glamping_02} className="d-block w-100" alt="Глэмпинг На Севере"/>
                            </div>
                            <div className="carousel-item">
                                <img src={glamping_04} className="d-block w-100" alt="Глэмпинг На Севере"/>
                            </div>
                            <div className="carousel-item">
                                <img src={glamping_05} className="d-block w-100" alt="Глэмпинг На Севере"/>
                            </div>
                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#glamping"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#glamping"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    Вечером идём парится в&nbsp;местную баньку. Погода шепчет. В&nbsp;предбаннике не&nbsp;работают новые обогреватели, т.к. они подключены к&nbsp;неработающим розеткам. &laquo;Ребята накосячили&raquo;!
                    </p>

                    <p>
                    Но&nbsp;в&nbsp;итоге всё исправили, и&nbsp;мы&nbsp;кайфанули...
                    </p>

                    <img src={glamping_01} className="img-fluid travel__img" loading="lazy" alt="Глэмпинг На Севере"/>

                    <p>
                    На&nbsp;следующий день, ещё немного покрутились в&nbsp;окрестностях. Посмотрели горы.
                    </p>

                    <div id="khubiny" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#khubiny" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#khubiny" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={khibiny_01} className="d-block w-100" alt="Хибины}"/>
                            </div>
                            <div className="carousel-item">
                                <img src={khibiny_02} className="d-block w-100" alt="Хибины"/>
                            </div>

                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#khubiny"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#khubiny"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    Ну&nbsp;а&nbsp;после, со&nbsp;спокойным сердцем поехали обратно в&nbsp;Мурманск.
                    </p>

                    <p>
                    На&nbsp;следующий день сдаю машину и&nbsp;весь день свободен.
                    </p>

                    <p>
                    Гулям по&nbsp;городу, смотрим достопримечательности.
                    </p>

                    <div id="murmansk" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#murmansk" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#murmansk" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#murmansk" data-bs-slide-to="2"
                                    aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#murmansk" data-bs-slide-to="3"
                                    aria-label="Slide 4"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={murmansk_02} className="d-block w-100" alt="Мурмнск}"/>
                            </div>
                            <div className="carousel-item">
                                <img src={murmansk_03} className="d-block w-100" alt="Мурмнск"/>
                            </div>
                            <div className="carousel-item">
                                <img src={murmansk_04} className="d-block w-100" alt="Мурмнск"/>
                            </div>
                            <div className="carousel-item">
                                <img src={murmansk_05} className="d-block w-100" alt="Мурмнск"/>
                            </div>
                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#murmansk"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#murmansk"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    Вечером идём в&nbsp;один из&nbsp;лучших ресторанов Мурманска &laquo;Тундра&raquo;, пробовать местные деликатесы с&nbsp;олениной и&nbsp;крабами. Реально достойное заведение с&nbsp;внимательным обслуживанием.
                    </p>

                    <div id="tundra" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#tundra" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#tundra" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={tundra_01} className="d-block w-100" alt="Ресторан Тундра}"/>
                            </div>
                            <div className="carousel-item">
                                <img src={tundra_02} className="d-block w-100" alt="Ресторан Тундра"/>
                            </div>
                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#tundra"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#tundra"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    Летим обратно в&nbsp;Москву. Прилетаем уже к&nbsp;ночи. Ночуем поближе к&nbsp;Лёхе. Так удобнее с&nbsp;дороги.
                    </p>

                    <img src={moskowBack} className="img-fluid travel__img" loading="lazy" alt="Москва"/>

                    <p>
                    На&nbsp;следующий день перебираемся на&nbsp;место нашей последней дислокации. Рядом с&nbsp;метро &laquo;Тульская&raquo;.
                    </p>

                    <div id="tulskaya" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#tulskaya" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#tulskaya" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={tulskaya} className="d-block w-100" alt="Тульская}"/>
                            </div>
                            <div className="carousel-item">
                                <img src={tulskayaFlat} className="d-block w-100" alt="Тульская"/>
                            </div>
                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#tulskaya"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#tulskaya"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    Здесь живём и&nbsp;гуляем по&nbsp;Москве ещё несколько дней.
                    </p>

                    <div id="moskowCity" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#moskowCity" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#moskowCity" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={moskowCity_01} className="d-block w-100" alt="Москва Сити}"/>
                            </div>
                            <div className="carousel-item">
                                <img src={moskowCity_02} className="d-block w-100" alt="Москва Сити"/>
                            </div>
                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#moskowCity"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#moskowCity"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    Ходили на&nbsp;ВДНХ.
                    </p>

                    <div id="VDNH" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#VDNH" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#VDNH" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#VDNH" data-bs-slide-to="2"
                                    aria-label="Slide 3"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={moskowVDNH_02} className="d-block w-100" alt="Москва Сити}"/>
                            </div>
                            <div className="carousel-item">
                                <img src={moskowVDNH_03} className="d-block w-100" alt="Москва Сити"/>
                            </div>
                            <div className="carousel-item">
                                <img src={moskowVDNH_04} className="d-block w-100" alt="Москва Сити"/>
                            </div>
                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#VDNH"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#VDNH"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    Пока сын ходил в&nbsp;местный аквариум. Я&nbsp;прятался от&nbsp;дождя под шатлом &laquo;Буран&raquo;.
                    </p>

                    <img src={moskowVDNH_01} className="img-fluid travel__img" loading="lazy" alt="Москва"/>

                    <p>
                    По&nbsp;центру Москвы были установлены множество развлекательных площадок для жителей и&nbsp;гостей столицы &laquo;Лето в&nbsp;Москве&raquo;. Всё бесплатно.
                    </p>

                    <div id="leto_02" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#leto_02" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#leto_02" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={moskowLeto_02} className="d-block w-100" alt="Лето в Москве"/>
                            </div>
                            <div className="carousel-item">
                                <img src={moskowLeto_04} className="d-block w-100" alt="Лето в Москве"/>
                            </div>
                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#leto_02"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#leto_02"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    Рады не&nbsp;только лишь дети...
                    </p>

                    <div id="leto_01" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#leto_01" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#leto_01" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={moskowLeto_01} className="d-block w-100" alt="Лето в Москве"/>
                            </div>
                            <div className="carousel-item">
                                <img src={moskowLeto_03} className="d-block w-100" alt="Лето в Москве"/>
                            </div>
                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#leto_01"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#leto_01"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    С&nbsp;женой ходили в&nbsp;новые кварталы с&nbsp;современной архитектурой.
                    </p>

                    <img src={moskowNewArc_01} className="img-fluid travel__img" loading="lazy" alt="Москва"/>

                    <p>
                        Очень впечатляет.
                    </p>

                    <div id="newArc" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#newArc" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#newArc" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={moskowNewArc_02} className="d-block w-100" alt="Москва"/>
                            </div>
                            <div className="carousel-item">
                                <img src={moskowNewArc_03} className="d-block w-100" alt="Москва"/>
                            </div>
                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#newArc"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#newArc"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    Просто много ходили.
                    </p>

                    <div id="moskowWalk" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#moskowWalk" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#moskowWalk" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#moskowWalk" data-bs-slide-to="2"
                                    aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#moskowWalk" data-bs-slide-to="3"
                                    aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#moskowWalk" data-bs-slide-to="4"
                                    aria-label="Slide 5"></button>
                            <button type="button" data-bs-target="#moskowWalk" data-bs-slide-to="5"
                                    aria-label="Slide 6"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={moskowWalk_01} className="d-block w-100" alt="Москва"/>
                            </div>
                            <div className="carousel-item">
                                <img src={moskowWalk_02} className="d-block w-100" alt="Москва"/>
                            </div>
                            <div className="carousel-item">
                                <img src={moskowWalk_03} className="d-block w-100" alt="Москва"/>
                            </div>
                            <div className="carousel-item">
                                <img src={moskowWalk_04} className="d-block w-100" alt="Москва"/>
                            </div>
                            <div className="carousel-item">
                                <img src={moskowWalk_05} className="d-block w-100" alt="Москва"/>
                            </div>
                            <div className="carousel-item">
                                <img src={moskowWalk_06} className="d-block w-100" alt="Москва"/>
                            </div>
                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#moskowWalk"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#moskowWalk"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    С&nbsp;сыном заходили в&nbsp;Яндекс музей. Попали туда почти случайно. Но&nbsp;ребёнка было от&nbsp;туда за&nbsp;уши не&nbsp;оттащить...
                    </p>

                    <div id="yandexMuseum" className="carousel slide" data-bs-ride="true">
                        <div className="carousel-indicators">
                            <button type="button" data-bs-target="#yandexMuseum" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#yandexMuseum" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#yandexMuseum" data-bs-slide-to="2"
                                    aria-label="Slide 3"></button>
                            <button type="button" data-bs-target="#yandexMuseum" data-bs-slide-to="3"
                                    aria-label="Slide 4"></button>
                            <button type="button" data-bs-target="#yandexMuseum" data-bs-slide-to="4"
                                    aria-label="Slide 5"></button>
                            <button type="button" data-bs-target="#yandexMuseum" data-bs-slide-to="5"
                                    aria-label="Slide 6"></button>
                            <button type="button" data-bs-target="#yandexMuseum" data-bs-slide-to="6"
                                    aria-label="Slide 7"></button>
                        </div>

                        <div className="carousel-inner travel__img">
                            <div className="carousel-item active">
                                <img src={yandexMuseum_01} className="d-block w-100" alt="Яндекс музей"/>
                            </div>
                            <div className="carousel-item">
                                <img src={yandexMuseum_02} className="d-block w-100" alt="Яндекс музей"/>
                            </div>
                            <div className="carousel-item">
                                <img src={yandexMuseum_03} className="d-block w-100" alt="Яндекс музей"/>
                            </div>
                            <div className="carousel-item">
                                <img src={yandexMuseum_04} className="d-block w-100" alt="Яндекс музей"/>
                            </div>
                            <div className="carousel-item">
                                <img src={yandexMuseum_05} className="d-block w-100" alt="Яндекс музей"/>
                            </div>
                            <div className="carousel-item">
                                <img src={yandexMuseum_06} className="d-block w-100" alt="Яндекс музей"/>
                            </div>
                            <div className="carousel-item">
                                <img src={yandexMuseum_07} className="d-block w-100" alt="Яндекс музей"/>
                            </div>
                        </div>
                        
                        <button className="carousel-control-prev" type="button" data-bs-target="#yandexMuseum"
                                data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>

                        <button className="carousel-control-next" type="button" data-bs-target="#yandexMuseum"
                                data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>

                    <p>
                    В&nbsp;целом весёлая была поездочка
                    </p>

                    
                    <br />

                    <div className="travel__iframeWrap">
                        <iframe className="travel__iframe" 
                                src="https://www.youtube.com/embed/2udH7yLZGL0?si=Nswim-v1K75sXCAd" 
                                frameborder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" 
                                allowfullscreen>
                        </iframe>
                    </div>

                    <br />

                    <div className="travel__iframeWrap">
                        <iframe className="travel__iframe" 
                                src="https://www.youtube.com/embed/HAv1p4FHBE4?si=GnjxPs3FBtaBObzy" 
                                frameborder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" 
                                allowfullscreen>
                        </iframe>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Murmansk;